import React from 'react';
import {useProspectScoreSettingQuery, LeadSource} from 'api';

export default () => {
  const {data: {prospectScoreSetting = {}} = {}} = useProspectScoreSettingQuery(
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  return (
    <div className="flex flex-col gap-2">
      {Object.entries(
        prospectScoreSetting?.leadSourcesGroupByPriority ?? {},
      )?.map(([priority, leadSources]: any) => {
        return (
          <div className="flex gap-2" key={priority}>
            <div className="font-bold text-sm">優先度{priority}</div>
            <div className="flex items-center gap-2 text-sm">
              {leadSources
                .map((leadSource: LeadSource) => {
                  return leadSource.name;
                })
                ?.join(' | ')}
            </div>
          </div>
        );
      })}
    </div>
  );
};
